__webpack_require__.p = "//testbhgst.imgix.net/dist/13816/badshop/client/";